import React from "react";

import { Container } from "@components/Layout/Container";
import { Section } from "@components/Layout/Section";

import { Intro } from "./Intro";
import * as Styled from "./Features.styled";
import { Bento6x6 } from "./Bento6x6";

export const Features: React.FC<{ language: string }> = ({ language }) => {
  return (
    <Section
      backgroundColor="yellow500"
      bolt={{
        variant: "right",
        color: "white",
      }}
    >
      <Container>
        <Styled.Root>
          <Intro />
          <Bento6x6 language={language} />
        </Styled.Root>
      </Container>
    </Section>
  );
};
